import { TendersSortName } from 'src/models/procurements/Tenders/types';
import { BidsColumn } from 'src/models/bids/Bids/types';
import { ActivePreviewTab } from 'src/models/procurements/types';

export enum PageName {
  'bids' = 'bids',
  'allTenders' = 'allTenders',
  'mpTenders' = 'mpTenders',
  'starredTenders' = 'starredTenders',
  'callOffs' = 'callOffs',
  'tasks' = 'tasks',
  'users' = 'users',
  'expiringContracts' = 'expiringContracts',
  'buyerProfiles' = 'buyerProfiles',
  'tenderNavMonitoring' = 'tenderNavMonitoring',
  'tenderNavProjectBid' = 'tenderNavProjectBid',
  'tenderNavAnalytics' = 'tenderNavAnalytics'
}

export enum PageView {
  table = 'table',
  board = 'board',
  timeline = 'timeline',
  collapsed = 'collapsed',
  expanded = 'expanded'
}

export interface IPagePreferences {
  id: PageName;
  view?: PageView;
  columns?: TendersSortName | BidsColumn;
  tab?: ActivePreviewTab;
}

export interface IUserPreferences {
  minimal: boolean;
  pages?: IPagePreferences[];
}

export const DEFAULT_TENDER_NAV_VIEW = PageView.expanded;
